import { FC, useMemo } from "react";
import classNames from "classnames";
import { message } from "antd";

import styles from "./index.less";

import { PayType } from "../../../../service";

interface PaySelectMethodProps {
  payAmount?: number;
  allowedMethods: PayType[];
  balance?: number;
  value?: PayType;
  onChange?: (value: PayType) => void;
}

/**
 * 支付方式
 * @returns
 */
const PaySelectMethod: FC<PaySelectMethodProps> = ({
  payAmount,
  allowedMethods,
  balance,
  value,
  onChange,
}) => {
  const canUseBalanceToPay = useMemo(() => {
    return balance && balance > 0 && payAmount && payAmount <= balance;
  }, [balance, payAmount]);

  const PayMethodLabelMap = useMemo(() => {
    return {
      [PayType.ALIPAY]: "支付宝支付",
      [PayType.WECHAT]: "微信支付",
      [PayType.OFFLINE]: "银行转账",
      [PayType.BALANCE]: "余额支付",
    };
  }, []);

  return (
    <div className={styles.container}>
      {allowedMethods.map((method) => (
        <div
          className={classNames(styles.item, {
            [styles["item-selected"]]: value === method,
            [styles["item-disabled"]]:
              method === PayType.BALANCE && !canUseBalanceToPay,
          })}
          key={method}
          onClick={() => {
            if (method === PayType.BALANCE && !canUseBalanceToPay) {
              message.info("余额不足，请选择其他方式支付");
              return;
            }

            onChange?.(method);
          }}
        >
          <div className={styles.label}>{PayMethodLabelMap[method]}</div>
          {method === PayType.BALANCE && (
            <div className={styles.balance}>
              剩余：{balance ? `¥${balance}` : "--"}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PaySelectMethod;
